import { Collection } from 'modules/core/lib/mobx-rest'

import Supplement from 'modules/payroll_bundle/store/models/Supplement'

export class Supplements extends Collection<Supplement> {
  get cacheKey(): string {
    return 'supplements'
  }

  model() {
    return Supplement
  }
}

const singleton: Supplements = new Supplements([])

export default singleton
